<script>
import { resolveEntityImageUrl } from "../../../../utils/entityImageUrl";

export default {
  props: ['filter', 'available_filters'],
  methods: {
    resolveEntityImageUrl,
    toggleFilter(domain_name) {
      if(this.filter.includes(domain_name)) {
        const index = this.filter.indexOf(domain_name);

        if (index > -1) {
          this.filter.splice(index, 1);
        }
      } else {
        this.filter.push(domain_name);
      }
    },
    clearFilter() {
      this.filter.splice(0, this.filter.length)
    }
  }
}
</script>

<template>
  <div class="filters">
    <button class="button button_filters mr-1" @click="clearFilter">
      {{ $t('filters.show_all') }}
    </button>
    <span class="filters__text">{{ $t('filters.filter') }}:</span>
    <button class="filters__icon"
      :class="{'active': this.filter.includes('creation')}"
      :disabled="!available_filters.includes('creation')"
      @click="toggleFilter('creation')">
      <img :src="resolveEntityImageUrl('/images/spells/filter1.webp')">
    </button>
    <button class="filters__icon"
      :class="{'active': this.filter.includes('destruction')}"
      :disabled="!available_filters.includes('destruction')"
      @click="toggleFilter('destruction')">
      <img :src="resolveEntityImageUrl('/images/spells/filter2.webp')">
    </button>
    <button class="filters__icon"
      :class="{'active': this.filter.includes('life')}"
      :disabled="!available_filters.includes('life')"
      @click="toggleFilter('life')">
      <img :src="resolveEntityImageUrl('/images/spells/filter3.webp')">
    </button>
    <button class="filters__icon"
      :class="{'active': this.filter.includes('death')}"
      :disabled="!available_filters.includes('death')"
      @click="toggleFilter('death')">
      <img :src="resolveEntityImageUrl('/images/spells/filter4.webp')">
    </button>
  </div>
</template>
